import { ScrollTrigger } from "../LibrariesImport";
import { GlobalVariables } from "../GlobalVariables";
import HomeBannerTextReveal from "../animations/HomeBannerTextReveal";

// Colle légère entre la bannière home 3D (bundle séparé, cf. HomeBanner.js /
// app/js/three/*) et l'infra ScrollTrigger/Lenis partagée du site. Le moteur
// 3D lui-même ne dépend jamais de GSAP : il expose juste setScrollProgress()
// et signale sa disponibilité via l'event "homeBanner3dReady", pour rester
// indépendant du bundle principal (un seul GSAP/ScrollTrigger doit exister).
//
// Pas de pin : le fond 3D est simplement "position: fixed" en CSS tant que
// .banner-home est à l'écran (cf. _banner-home.scss). Le titre et l'intro
// défilent avec la page comme un contenu normal — scrub uniquement, pour
// dériver scrollT de la position de scroll réelle.
export default class BlockBannerHome3D {
	constructor() {
		const root = document.querySelector("[data-home-3d]");
		if (!root) return;

		this.instance = null;
		window.addEventListener("homeBanner3dReady", (e) => {
			this.instance = e.detail.instance;
		});

		new HomeBannerTextReveal(document);

		// Reduced-motion : pas de scrub, le fond 3D reste figé sur l'état final de
		// la scène 1 (cf. HomeBannerScene._snapIntroToEnd), titre/intro défilent déjà
		// normalement (absolute dans le flux, pas de sticky/fixed à désactiver).
		if (GlobalVariables.reducedMotion) return;

		ScrollTrigger.create({
			trigger: root,
			start: "top top",
			end: "bottom bottom",
			scrub: 1,
			onUpdate: (self) => {
				if (this.instance) this.instance.setScrollProgress(self.progress);
			},
		});

		// Sortie : les 100vh qui séparent la fin du scrub (bas de la bannière au bas
		// du viewport) du moment où le fond fixe est masqué (bas de la bannière au
		// haut du viewport). Sans ça, la scène restait plein écran par-dessus le
		// premier bloc de la page jusqu'à disparaître d'un coup.
		ScrollTrigger.create({
			trigger: root,
			start: "bottom bottom",
			end: "bottom top",
			onUpdate: (self) => {
				if (this.instance) this.instance.setOutroProgress(self.progress);
			},
		});
	}
}
